import { atom } from "recoil"

export const currentDiagnosisAtom = atom({
    key: "currentDiagnosisAtom",
    default: null
})

export const educationalDiagnosisVisioAtom = atom({
    key: "educationalDiagnosisVisioAtom",
    default: null
})

export const diagnosisStatusAtom = atom({
    key: "diagnosisStatusAtom",
    default: []
})

export const diagnosisShouldUpdateAtom = atom({
    key: "diagnosisShouldUpdateAtom",
    default: false
})

export const allAxisAtom = atom({
    key: "allAxisAtom",
    default: []
})
